module.exports = __webpack_public_path__ + "img/start.3c9df08a.svg";